/**
 * @description ページ遷移anim
 */

export const setPageTransition = () => {
  //ページ遷移anim
  $(function () {
    $('body').removeClass('is-fadeout');
  });

  //外部,telリンクは除外
  $('a:not([href^="#"]):not([target])').on('click', function (e) {
    if ($(e.target).hasClass('js-notfade')) return;
    e.preventDefault();

    const url = $(this).attr('href')!;
    if (url !== '') {
      $('body').addClass('is-fadeout');
      setTimeout(function () {
        window.location.href = url;
      }, 300);
    }
    return false;
  });

  //ブラウザバックのときreload
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  });
};
